module.exports = __webpack_public_path__ + "media/audio20.09e22425.wav";